export default "__VITE_ASSET__bf056a3e__"